export default __webpack_public_path__ + "static/yield-optimizer-hands-free-ai-gradient-bd53d1a922149bb6ef4706d466912083.svg";